import { Base } from "@studiometa/js-toolkit";
import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

export default class SliderTabs extends Base {
  static config = {
    name: 'SliderTabs',
    refs: ['wrapper', 'slides[]', 'scrollbar'],
    log: true,
  };

  mounted() {
    this.$log('mounted swipe tab');
    this.init();
  }

  init() {
    this.slider = new Swiper(this.$el, {
      modules: [Scrollbar],
      direction: 'horizontal',
      allowTouchMove: true,
      scrollbar: {
        el: this.$refs.scrollbar,
        draggable: true,
        hide: false,
        dragSize: 'auto',
      },
    });
  }

  destroyed() {
    if (this.slider) {
      this.slider.destroy(true, true);
    }
  }
}
